import * as React from 'react';
import { useCheckboxGroupOptions } from '../../internal';
import { ControlButtonGroup } from '../../../internal/components/ControlButton';
import { CheckboxButton } from '../CheckboxButton';
import { jsx as _jsx } from "react/jsx-runtime";
function CheckboxButtonGroupComponent(props) {
  const {
    value,
    defaultValue,
    disabled,
    invalid,
    name,
    role,
    spliced,
    inline,
    size
  } = props;
  const options = useCheckboxGroupOptions(props);
  return /*#__PURE__*/_jsx(ControlButtonGroup, {
    role: role,
    spliced: spliced,
    inline: inline,
    children: options.map(option => {
      const key = String(option.value);
      return /*#__PURE__*/_jsx(CheckboxButton, {
        name: name,
        value: key,
        checked: value && !!value.find(v => v === option.value),
        defaultChecked: !!(defaultValue || []).find(v => v === option.value) || undefined,
        disabled: disabled,
        invalid: invalid,
        label: option.label,
        onChange: option.onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size
      }, key);
    })
  });
}

/**
 * Компонент для работы с CheckboxButton как с группой
 *
 * ВНИМАНИЕ:
 * При использовании вблизи края станицы может выходить отступом за края, создавая скролл
 * Чтобы этого не было, убедитесь что обертка страницы имеет overflow-x: hidden
 *
 * @deprecated использовать компонент CheckboxChipsGroup
 *
 * @export
 * @param {ICheckboxButtonGroupProps} props
 * @returns
 */
export const CheckboxButtonGroup = /*#__PURE__*/React.memo(CheckboxButtonGroupComponent);